export const ScreenReader = {
  speak: (text: string, priority: "polite" | "assertive" = "polite"): void => {
    if (typeof document === "undefined" || typeof window === "undefined") {
      return;
    }

    const el = document.createElement("div");
    const id = "speak-" + Date.now();
    el.setAttribute("id", id);
    el.setAttribute("aria-live", priority);
    el.classList.add("aria-invisible");
    document.body.appendChild(el);

    window.setTimeout(() => {
      const targetElement = document.getElementById(id);
      if (targetElement) {
        targetElement.innerHTML = text;
      }
    }, 100);

    window.setTimeout(() => {
      const elementToRemove = document.getElementById(id);
      if (elementToRemove) {
        document.body.removeChild(elementToRemove);
      }
    }, 3000);
  },
};
